<template>
  <div class="mb-3">
    <span class="ebike-label">Is it an e-bike?</span>
    <div class="is-flex is-justify-content-flex-start">
      <div
        class="ebike-option is-flex is-justify-content-center"
        :class="{ selected: isEbike }"
        @click="selectOption(true)"
      >
        <div>Yes</div>
        <div>
          <div class="indicator" :class="{ selected: isEbike }" />
        </div>
      </div>
      <div
        class="ebike-option is-flex is-justify-content-center"
        :class="{ selected: isEbike === false }"
        @click="selectOption(false)"
      >
        <div>No</div>
        <div>
          <div class="indicator" :class="{ selected: isEbike === false }" />
        </div>
      </div>
    </div>
    <span v-if="errorMessage" class="error">
      {{ errorMessage }}
    </span>
    <div v-if="isEbike" class="warning-text">
      *Please note we cannot insure your e-bike unless it is road legal. If your
      e-bike has a maximum power output above 250 watts or its motor provides
      assistance at speeds above 15.5mph we are unable to cover it.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // `default: null` is load-bearing. A Boolean prop with no default is cast
    // to `false` when the parent omits it, so this component used to answer
    // the question itself, showing "No" while never emitting it — the parent
    // and the quote payload kept `null`. The default now lives in the parent,
    // and this stays a component that only displays what it is handed.
    isEbikeProps: {
      type: Boolean,
      default: null,
    },
  },
  data: () => {
    return {
      isEbike: null,
      errorMessage: null,
    }
  },
  computed: {},
  watch: {
    // The parent can answer this from a landing page the customer arrived on,
    // after this component has already been created and cached.
    isEbikeProps(value) {
      this.isEbike = value
    },
  },
  created() {
    this.isEbike = this.isEbikeProps
  },
  methods: {
    selectOption(value) {
      this.isEbike = value
      this.errorMessage = null
      this.$emit('isEbikeSelected', value)
    },
    validate() {
      if (this.isEbike === null) {
        this.errorMessage = 'This filed is requred'
        return false
      } else {
        return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.indicator {
  width: 24px;
  height: 24px;
  margin: 0 0 0 10px;
  border-radius: 50%;
  border: 2px solid $ps-border-color;
  position: relative;
  flex: 0 0 auto;
  &.selected {
    border: 0;
    &:before {
      content: '';
      display: block;
      width: 30px;
      height: 30px;
      background: $ps-primary;
      border-radius: 50%;
      position: absolute;
      background: url('~/assets/images/icons/shield.svg') no-repeat;
      // Centres the 30px shield over the 24px indicator.
      left: -3px;
      top: -3px;
    }
  }
}
// Same caps label style as every other field label.
.ebike-label {
  display: block;
  margin-bottom: 8px;
  font-size: $ps-text-label;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: $ps-muted;
}
// Same box as the text inputs above it: 1.5px token border, 12px radius,
// 56px tall.
.ebike-option {
  display: flex;
  align-items: center;
  justify-content: center;
  height: $ps-control-h;
  border: 1.5px solid $ps-border-color;
  border-radius: $ps-radius-md;
  width: 120px;
  margin: 10px 10px 10px 0;
  padding: 0 18px;
  font-size: $ps-text-body;
  color: $ps-body-color;
  background: #fff;
  text-align: center;
  cursor: pointer;
  transition: border-color 120ms ease, background-color 120ms ease;

  &.selected {
    border-color: $ps-primary;
    color: $ps-primary;
  }
}
.warning-text {
  font-size: $ps-text-small;
  color: $ps-primary;
}
.error {
  color: $ps-error;
  font-size: $ps-text-small;
}
</style>
